// What the photo dedup means for the editor (owner, 2026-10-24, worker
// lib/photoDedupLayout.ts + migration 267).
//
//   hidden duplicate  the worker's photo list leaves it out and hands it back
//                     apart (`hidden_duplicates`) for the tray's « Doublons
//                     masqués » section — one click « Restaurer ».
//   layout_hold       'similar' — a burst shot. Listed, counted, in the tray;
//                     the layout (« Régénérer ») leaves it out unless a person
//                     already put it on a page. She can still drag it in.
//
// Guard: src/lib/photoDedup.test.ts

export interface DedupMarked {
  id: string;
  layout_hold?: string | null;
  duplicate_of?: string | null;
}

/** The photos an automatic layout may place. */
export function forAutomaticLayout<T extends DedupMarked>(photos: T[], placedIds: ReadonlySet<string>): T[] {
  return (photos ?? []).filter((p) => {
    if (p.duplicate_of) return false;
    if (p.layout_hold === 'similar') return placedIds.has(p.id);
    return true;
  });
}

/** Every photo id on these pages. */
export function placedIdsOf(pages: ReadonlyArray<{ photos?: ReadonlyArray<string | null | undefined> | null }> | null | undefined): Set<string> {
  const out = new Set<string>();
  for (const pg of pages ?? []) for (const id of pg?.photos ?? []) if (id) out.add(id);
  return out;
}
